import React from 'react';
import { motion } from 'framer-motion';
export function Benefits() {
  return <section className="py-8 px-4 text-center" data-id="element-19">
      <div className="max-w-xl mx-auto" data-id="element-20">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-21">
          <h2 className="text-2xl sm:text-3xl font-black text-swiss-charcoal mb-3" data-id="element-22">
            Das W&R Komplett-System
          </h2>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed font-medium" data-id="element-23">
            Das erste vollständige digitale Lehrsystem, das speziell für
            Schweizer Lehrpersonen der Sekundarstufe II entwickelt wurde.
          </p>
          <p className="text-lg sm:text-xl font-black text-swiss-blue-expert mt-4" data-id="element-24">
            Ein Download. Ein ganzes Jahr. Null Stress.
          </p>
        </motion.div>
      </div>
    </section>;
}